import formula from '@/components/caculator/lib/calFormula.js';
import ThreeDTour from '@/components/threed-tour/index.js';
import util from '@/common/util.js';
import { dateFormat, numberFormat } from '@/common/format';
import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore, useUserStore } from "@/store";

import { mapState, mapActions } from '@/store/helpers';
import signLog from '@/components/sign-log';
import Caculator from '@/components/caculator/index.js';
import { normal } from '../defaultSpacing';
import { getListingDetailSchemaInfo } from '@/common/schemaInfo.js';
import MediaPop from '../md-detail-info/media-pop.vue';
import GalleryPop from '../md-detail-info/gallery-pop.vue';
import MediaPopLayout from '../md-detail-info/media-pop-layout.vue';
import GalleryPopLayout from '../md-detail-info/gallery-pop-layout.vue';
import SharePop from './_components/share-pop.vue';
import RequestPop from './_components/est-request-pop.vue'
import popMgr from '@/components/global/popMgr';
import { INTERCEPT_MLS } from '@/common/customize';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, getAgent } from './asyncData';

import useStore from './_store';
import { isUrls } from '../../router';
export default {
    emits: ['readMore'],
    i18next: {
        ns: 'md-sold-detail'
    },
    asyncData: mapAsyncData(asyncData),
    _getUseStore: useStore,
    data: function() {
        let config = {
            payment: {
                downPaymentRatio: 20,
                propertyTaxRate: 0,
                loanTerm: 30,
                interestRate: 4,
                homeInsurance: 0,
                hoaFee: 0,
                chimeMaintenanceFee: 0
            }, // Calculator parameters
            agentId: 0, //
            originPriority: true, // Priority will be shown to those who own the listing Agent
            showCoAgent: false, // whether to show cooperation agent
            triggerCalculator: false, // Do you need to log in to click the calculator
            triggerReadMore: false, // click Read More Do you need to log in
            readMoreExpanded: false, // Whether to expand by default Read More
            calcInfo: {},
            submitText: '',
        };
        return {
            ...config,
            listingDetail: {}, //  Basic information of the property
            showReadMore: true, // whether to display Read More
            estPriceValue: 0, // Valuation
            ...normal,
            paymentText: '',
            requestButtonText: ''
        };
    },
    watch: {
        originPriority() {
            this.getAgent();
        },
        showCoAgent(value) {
            this.updateShowCoAgent(value);
            this.getAgent();
        },
        readMoreExpanded(value) {
            this.updateOpenReadMore(value);
        },
        shareLinks(value) {
            this.updateShare(value);
        }
    },
    provide() {
        return {
            click3D: this.click3D,
            getMediaPopIns: this.createMediaPop,
            getGalleryPopIns: this.createGalleryPop,
            onFavoriteClick: null,
            showSoldPrice: this.showSoldPrice,
            sharePop: this.sharePop,
            request: this.request
        };
    },
    created() {
        this.listingDetail = this.listingDetail || {};
        this.updateListingDetail(this.listingDetail);
        this.updatePayment(this.payment);
        this.upTriggerReadMore(this.triggerReadMore);
        this.updateOpenReadMore(this.readMoreExpanded || this.platform.isBot);
        this.updateShare(this.shareLinks);
    },
    beforeMount() {
        this.getMortgage();
        !this.hasSave && this.getUpData();
        this.mlsListTrac();
    },
    mounted() {
        if (this.hasLoggedIn) {
            this.$EventBus.$emit('siteTrack', {
                listingId: this.info.id,
                trackType: 'view_five_properties',
                listingType: 0 // 1 - active listing, 0 - sold listing
            });
            this.$EventBus.$emit('siteTrack', {
                listingId: this.info.id,
                trackType: 'view_three_sold_properties',
                listingType: 0 // 1 - active listing, 0 - sold listing
            });
        }
        this.updateShowCoAgent(this.showCoAgent);
    },
    computed: {
        house({ page }) {
            return page.house || {};
        },
        hidePrice({ house, showSoldPrice, info }) {
            return !house.showListingPrice && !showSoldPrice && info.soldDate; // Whether to hide selling price and original price ， yes show asterisk
        },
        showSoldPrice({ house, page, info }) {
            let curMls = page.mlsOrgs.find(mls => mls.id === info.mlsOrg?.id)
            let showSoldPrice = curMls?.showSoldPrice && house?.showSoldPrice
            return showSoldPrice // Whether to display the selling price
        },
        showListingPrice({ house }) {
            return house.showListingPrice; // Whether to display the original price
        },
        cmpNondisclosureDes() {
            return (
                this.nodisclosureDes ?? this.$t('md-sold-detail.nondisclosure')
            );
        },
        cmpPaymentText() {
            return this.paymentText || this.$t('md-sold-detail.estPayment');
        },
        seoSchema({ page }) {
            return getListingDetailSchemaInfo(this.info, {
                country: page.country,
                location: this.pageLocation,
                currencyAbbr: this.currencyAbbr,
                agentCreator: page.agentCreator,
            });
        },
        ...rootMapState(usePageStore, {
            page: store => store.page || {},
            currencyAbbr: store => store.currency.abbr,
            currencySymbol: store => store.currency?.symbol,
            siteId: store => store.siteId,

        }),
        ...rootMapState(useUserStore, {
            user: store => store.user,
            hasLoggedIn: store => store.hasLoggedIn,
            userEmailVerified: store => store.userEmailVerified
        }),

        ...mapState({
            shares: store => store.shares,
            openReadMore: store => store.openReadMore,
            pricePerMonth: store => store.pricePerMonth,
            tourBtnList: store => store.tourBtnList || [],
            listingGroups: store => store.listingDetail.listingGroups,
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        info() {
            return this.listingDetail.info || {};
        },
        isSold() {
            return this.info.listingStatus === 'Sold';
        },
        positionProvidedTop() {
            let mlsOrg = this.info.mlsOrg;
            return mlsOrg && mlsOrg.listingProviderDirection === 1; //1:above,2:under
        },
        showCalculator() {
            return (
                this.info.purchaseType != 'For Rent' &&
                this.info.statusOrigin != 'Leased' &&
                !this.info.pricePerMonth
            );
        },
        soldDate() {
            let time = dateFormat('MM/dd/yyyy', this.info.soldDateStr, this.$pinia);
            if (this.info.statusOrigin == 'Leased') {
                return this.$t('md-sold-detail.leasedDate', { time }); 
            } else {
                //CHIME-21882
                if (INTERCEPT_MLS.soldDate.includes(util.getValueByPath(this.info, 'mlsOrg.id', 0))) {
                    return this.$t('md-sold-detail.specialSoldDate0', { time }); 
                } else {
                    return this.$t('md-sold-detail.soldDate0', { time }); 
                }
            }
        },
        trend() {
            let { soldPrice, price } = this.info;
            if (soldPrice && price && soldPrice != price) {
                let res = ((Math.abs(soldPrice - price) / price) * 100).toFixed(
                    1
                );
                if (parseFloat(res) == 0) {
                    // toFixed  later may be   0  or   0.0
                    return '';
                }
                return res + '%';
            } else {
                return '';
            }
        },
        isShowMask() {
            // soldProtected like "Sold,Active,Pending"
            let soldProtected = this.info.mlsOrg?.soldProtected || '';
            let flag = soldProtected.includes(this.info.listingStatus);
            let isVerified = this.userEmailVerified;
            return flag && !isVerified && this.pageLocation.query.vow !== '0';
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        shareLinks({ page }) {
            let shares = {
                facebookHref: '',
                twitterHref: '',
                linkedinHref: '',
                gmailHref: ''
            };
            const origin = this.pageLocation.origin;
            //  fourth set url for detailLink other for detailUrl
            const href = `${origin}/${
                this.info.detailUrl ||
                this.info.detailLink
            }`;
            shares.facebookHref = page.wordPressSSR
                ? `https://www.facebook.com/share.php?u=${href}`
                : this.listingDetail.facebookHref;
            shares.twitterHref = page.wordPressSSR
                ? `https://twitter.com/share?text=${this.$t(
                    'md-sold-detail.instantlyViewAllPhotos',
                    { link: href }
                )}`
                : this.listingDetail.twitterHref;
            shares.linkedinHref = page.wordPressSSR
                ? `https://www.linkedin.com/shareArticle?url=${href}&title=${this.$t(
                    'md-sold-detail.hotListingIn',
                    { city: this.info.city }
                )}`
                : this.listingDetail.linkedinHref;
            shares.gmailHref = page.wordPressSSR
                ? `mailTo:?subject=${
                      this.info.address
                  }&body=Hi. ${this.$t(
                      'md-sold-detail.takeALookAtThisProperty',
                      { link: href }
                  )}`
                : this.listingDetail.gmailHref;
            return shares;
        }
    },
    methods: {
        ...rootMapActions(usePageStore, ['getAgentInfo']),
        ...mapActions([
            'updateOpenReadMore',
            'updateShare',
            'updateListingDetail',
            'updatePayment',
            'upTriggerReadMore',
            'updatePerMonth',
            'toggleOpenReadMore',
            'updateShowCoAgent'
        ]),
        getMortgage() {
            this.axiosIns
                .get('/api-site/mortgage/getMortgage', {
                    params: {
                        mortgageType: 'detail-mortgage',
                        id: this.info.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data.propertyTaxRate != null) {
                        this.payment.propertyTaxRate = data.propertyTaxRate; 
                    }
                    if (data.hoaFee != null) {
                        this.payment.hoaFee = data.hoaFee; 
                    }
                    if (data.chimeMaintenanceFee != null) {
                        this.payment.chimeMaintenanceFee =
                            data.chimeMaintenanceFee; 
                    }
                    this.calcuPerMonth();
                });
        },
        sharePop() {
            popMgr.create(SharePop, {
                shares: this.shares,
                theme: this.theme
            });
        },
        request() {
            if (this.user && this.user.loginStatus !== -1) {
                popMgr.create(RequestPop, {
                    _storeName: this._storeName,
                    theme: this.theme,
                    submitText: this.submitText
                });
            } else {
                signLog.register(
                    {
                        registerTitle: null,
                        submitRegister: this.submitText
                    },
                    'evaluationRegister'
                );
            }
        },
        createMediaPop() {
            if (this.isMobileSize) {
                const component = this.theme !== 'layout1' ? MediaPop : MediaPopLayout
                return popMgr.create(component, {
                    listingDetail: this.listingDetail,
                    sharePop: this.sharePop,
                    theme: this.theme,
                    sold: this.isSold
                });
            }
        },
        createGalleryPop() {
            if (!this.isMobileSize) {
                const component = this.theme !== 'layout1' ? GalleryPop : GalleryPopLayout
                return popMgr.create(component, {
                    listingDetail: this.listingDetail,
                    shares: this.shares,
                    theme: this.theme,
                    sold: this.isSold
                });
            }
        },
        calcuPerMonth() {
            let info = this.info;

            this.payment.total = info.soldPrice;
            this.payment.downPaymentValue = (
                (this.payment.total * this.payment.downPaymentRatio) /
                100
            ).toFixed(3);
            this.payment.propertyTax = (
                (this.payment.total * this.payment.propertyTaxRate) /
                100
            ).toFixed(3);

            let result = formula(Object.assign({}, this.payment));
            let pricePerMonth = Object.values(result).reduce((prev, cur) => {
                return prev + +cur;
            }, 0);
            pricePerMonth = Math.round(pricePerMonth);
            this.updatePerMonth(pricePerMonth);
        },
        getAgent: mapAsyncData(getAgent),
        mlsListTrac() {
            if (this.info.mlsOrg && this.info.mlsOrg.listTrac === true) {
                util.addScript(
                    '//code.listtrac.com/monitor.ashx?acct=x_100692&nonjq=1',
                    true
                ).then(() => {
                    if (window._LT) {
                        window._LT._trackEvent(
                            window._eventType['view'],
                            this.info.mlsListingId,
                            this.info.zipCode,
                            this.info.agentLicense
                        );
                    }
                });
            }
        },
        click3D(url, theme) {
            if (this.isMobileSize) {
                window.open(url);
            } else {
                ThreeDTour.open({ url }, theme);
            }
        },
        openCaculator(theme) {
            if (this.hidePrice) {
                return;
            }
            if (!this.user && this.triggerCalculator) {
                signLog.register({
                    onsuccess: () => {
                        this.doOpenCaculator(theme);
                    },
                    onLogin: () => {
                        this.doOpenCaculator(theme);
                    }
                });
            } else {
                this.doOpenCaculator(theme);
            }
        },
        doOpenCaculator(theme) {
            Caculator.open(
                {
                    info: this.calcInfo,
                    initPayment: {
                        ...this.payment
                    },
                    onPermonthChange: money => {
                        this.updatePerMonth(money);
                    }
                },
                {},
                theme
            );
        },
        readMore(callback) {
            if (
                !this.user &&
                this.pageLocation.query.isPopup !== '0' &&
                this.triggerReadMore &&
                !this.readMoreExpanded
            ) {
                signLog.register({
                    onregister: () => {
                        this.doReadMore(callback);
                    },
                    onLogin: () => {
                        this.doReadMore(callback);
                    }
                });
            } else {
                this.doReadMore(callback);
            }
        },
        onReadMore() {
            this.readMore(() => {
                if (!this.openReadMore) {
                    this.$nextTick(() => {
                        this.$refs.detailInfo.scrollIntoView({
                            block: 'center',
                            inline: 'nearest',
                            behavior: 'smooth'
                        });
                    });
                }
                setTimeout(() => {
                    this.$emit('readMore');
                }, 0);
            });
        },

        doReadMore(callback) {
            this.toggleOpenReadMore();
            callback(this.openReadMore);
        },
        getUpData() {
            this.axiosIns
                .get('/api-site/place-data?fetcher=data&source=detailUpData')
                .then(res => {
                    let detailUpData = res.data || {};
                    if (typeof detailUpData === 'string') {
                        detailUpData = JSON.parse(detailUpData);
                    }
                    if (!isUrls({ names: ['sold-detail', 'listing-detail'], url: this.pageLocation.pathname })) {
                        delete detailUpData.triggerCalculator;
                        delete detailUpData.triggerReadMore;
                    }
                    for (let key in detailUpData) {
                        this[key] = detailUpData[key];
                    }
                });
        },
        count(type, value1, value2) {
            switch (type) {
            case 'bedrooms':
            case 'bathrooms':
                return numberFormat(value1, false, 2);
            case 'sqft':
                //sqft>0
                if (value1 > 0) {
                    return numberFormat(value1, false, 2);
                }
                //totalAvailableAcres>0
                if (value2 >= 10890) {
                    return numberFormat(value2 / (10890 * 4), false, 2);
                }
                return numberFormat(value2, false, 2);
            }
        },
        unit(type, value1, value2) {
            switch (type) {
            case 'bedrooms':
                return this.$t('md-sold-detail.bed', { count: value1 });
            case 'bathrooms':
                return this.$t('md-sold-detail.bath', { count: value1 });
            case 'sqft':
                //sqft>0
                if (value1 > 0) {
                    return this.$t('md-sold-detail.sqft');
                }
                //totalAvailableAcres>0
                if (value2 >= 10890) {
                    return this.$t('md-sold-detail.acresLot');
                }
                if (value2 > 0 && value2 < 10890) {
                    return this.$t('md-sold-detail.sqftLot');
                }
            }
        }
    }
};
